
export const countryCodeOptions = [
    {
        label: '美国',
        value: 'US'
    },
    {
        label: '越南',
        value: 'VN'
    },
    {
        label: "土耳其",
        value: 'TR'
    },
    {
        label: "法国",
        value: 'FR'
    },
    {
        label: "英国",
        value: 'UK'
    },
    {
        label: "塞浦路斯",
        value: 'CY'
    },
    {
        label: "日本",
        value: 'JP'
    },
    {
        label: "韩国",
        value: 'KR'
    },
    {
        label: "以色列",
        value: 'IL'
    },
]